/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationloaderror2Inputs */

const en_moderationloaderror2 = /** @type {(inputs: Moderationloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load reports`)
};

const de_moderationloaderror2 = /** @type {(inputs: Moderationloaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldungen konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Failed to load reports" |
*
* @param {Moderationloaderror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationloaderror2 = /** @type {((inputs?: Moderationloaderror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationloaderror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationloaderror2(inputs)
	return de_moderationloaderror2(inputs)
});
export { moderationloaderror2 as "moderationLoadError" }